{
  "id": "campaign-022",
  "name": "Breezy Commons",
  "seed": "campaign:22",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "...._.......",
    ",..~_.......",
    ".,~~_.......",
    ",..~_.......",
    "...._....x..",
    "..h._h..h..h",
    "____________",
    "...._.....zz",
    "...._.....z.",
    "..#._.....z.",
    "...._.....z.",
    "...._.....z.",
    "...._.....z.",
    "............",
    "...........S"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 2,
      "y": 0
    },
    {
      "kind": "squirrel",
      "x": 7,
      "y": 8
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 1,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 5
    },
    {
      "kind": "repair",
      "x": 1,
      "y": 11
    }
  ],
  "generatorVersion": 3,
  "level": 22,
  "biome": "park",
  "par": {
    "reel": 5643,
    "push": 4792,
    "selfPropelled": 4422,
    "tractor": 3795,
    "zeroTurn": 3078,
    "fairway": 2080
  },
  "routeTries": {
    "par": {
      "reel": 3,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 0,
      "zeroTurn": 0,
      "fairway": 21
    }
  }
}
